import { render, staticRenderFns } from "./verifyAccount.vue?vue&type=template&id=7ade64e8&scoped=true"
import script from "./verifyAccount.vue?vue&type=script&lang=js"
export * from "./verifyAccount.vue?vue&type=script&lang=js"
import style0 from "./verifyAccount.vue?vue&type=style&index=0&id=7ade64e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ade64e8",
  null
  
)

export default component.exports